import React from 'react'
import { useIntl } from 'react-intl'
import AssistChip from 'LuxKit/Chips/AssistChip'
import LinePhoneIcon from 'LuxKit/Icons/line/LinePhoneIcon'
import LineExcursionIcon from 'LuxKit/Icons/line/LineExcursionIcon'
import Group from 'components/utils/Group'
import type { GeoPlace } from 'tripPlanner/types/common'

interface Props {
  place: GeoPlace
  className?: string
}

function PlaceActionChips({
  place,

  className,
}: Props) {
  const intl = useIntl()
  return (
    <Group
      direction="horizontal"
      gap={8}
      wrap="wrap"
      className={className}
      noDisplayWhenEmpty
    >
      {place.internationalPhoneNumber && (
        <AssistChip
          variant="filled"
          href={`tel:${place.internationalPhoneNumber}`}
          startIcon={<LinePhoneIcon />}
          size="small"
        >
          {intl.formatMessage({
            id: 'n4_G2sUXpBwzplhOZq1y',
            defaultMessage: 'Call',
            description: 'Chip button to call a place via phone in the trip planner',
          })}
        </AssistChip>
      )}
      {place.website && (
        <AssistChip
          variant="filled"
          href={place.website}
          startIcon={<LineExcursionIcon />}
          size="small"
          target="_blank"
        >
          {intl.formatMessage({
            id: 'yzsiSsiVP5HCcVKVI_Vj',
            defaultMessage: 'Website',
            description: 'Chip button to visit the website of a place in the trip planner',
          })}
        </AssistChip>
      )}
    </Group>
  )
}

export default PlaceActionChips
